var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscordSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 31,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.037 2.87A31.764 31.764 0 0 0 24.99.342c-.347.626-.752 1.47-1.031 2.14-3-.451-5.972-.451-8.917 0-.28-.67-.693-1.514-1.043-2.14a31.658 31.658 0 0 0-8.052 2.534C.856 10.571-.525 18.075.166 25.472c3.377 2.522 6.65 4.054 9.868 5.056a24.546 24.546 0 0 0 2.113-3.48 20.783 20.783 0 0 1-3.328-1.62c.28-.207.552-.423.816-.646 6.417 3.002 13.39 3.002 19.73 0 .267.223.54.44.816.646a20.729 20.729 0 0 1-3.334 1.623 24.433 24.433 0 0 0 2.113 3.48c3.22-1.002 6.497-2.534 9.874-5.06.81-8.574-1.383-16.009-5.797-22.6ZM13.02 20.923c-1.926 0-3.506-1.799-3.506-3.989s1.546-3.991 3.506-3.991c1.96 0 3.54 1.798 3.506 3.991.004 2.19-1.545 3.989-3.506 3.989Zm12.957 0c-1.926 0-3.506-1.799-3.506-3.989s1.546-3.991 3.506-3.991c1.96 0 3.54 1.798 3.507 3.991 0 2.19-1.546 3.989-3.506 3.989Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordSymbol);
export default __webpack_public_path__ + "static/media/discordSymbol.2fe7d2244ff5d3f9a1b12c30ac551528.svg";
export { ForwardRef as ReactComponent };